import { render, staticRenderFns } from "./SideNav--Item-Icon.vue?vue&type=template&id=393746a7&"
import script from "./SideNav--Item-Icon.vue?vue&type=script&lang=js&"
export * from "./SideNav--Item-Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports